import Vue from 'vue'
import Router from 'vue-router'
import Accueil from '@/components/Accueil'
import Projets from '@/components/Projets'
import Sachassou from '@/components/projets/Sachassou'
import Datavisualisation from '@/components/projets/Datavisualisation'
import BelfortByNight from '@/components/projets/BelfortByNight'
import AssoLard from '@/components/projets/AssoLard'
import About from '@/components/About'


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'Accueil', component: Accueil },
    { path: '/projets', name: 'Projet', component: Projets },
    { path: '/sachassou', name: 'Sachassou', component: Sachassou },
    { path: '/datavisualisation', name: 'Datavisualisation', component: Datavisualisation },
    { path: '/belfort-by-night', name: 'BelfortByNight', component: BelfortByNight },
    { path: '/asso-lard', name: 'AssoLard', component: AssoLard },
    { path: '/a-propos', name: 'About', component: About },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js